import React from 'react';
import { ArticleHeading4, ArticleHeading3, UIText2 } from '@cian/ui-kit';
import styles from './styles.css';
import { useIsDesktop } from '../../../../hooks/common';

interface IInfoBlockProps {
  title: string;
  text: string;
}

export const InfoBlock: React.FC<IInfoBlockProps> = ({ title, text }) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <div className={styles['title']}>
        <UIText2 color={'current_color'}>{title}</UIText2>
      </div>
      {isDesktop ? <ArticleHeading4>{text}</ArticleHeading4> : <ArticleHeading3>{text}</ArticleHeading3>}
    </>
  );
};
